import { LogoutConfirmationComponent } from './../logout-confirmation/logout-confirmation.component';
import { AfterViewInit, Component, ElementRef, HostListener, OnDestroy, OnInit, Renderer2, RendererStyleFlags2, ViewChild, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { SessionService } from '../../../core/services/session.service';
import { UserAuthenticationService } from '../../../modules/authentication/services/user-authentication.service';
import { CustomerService } from '../../../modules/customer-zone/services/customer-service.service';
import { DynamicHeader } from '../../models/DynamicHeader';
import { Icon } from '../../models/icon';
import { ContractMenuItem } from '../../models/Navigation';
import { ScreenSize } from '../../models/screenSize';
import { RouteNames } from '../../routing/app-routing.constants';
import { ScreenSizeService } from '../../services/screenSize.service';
import { HelperService } from '../../services/helper.service';
import { SessionKeys } from '../../models/SessionKeys';

@Component({
  selector: 'app-dynamic-header',
  templateUrl: './dynamic-header.component.html',
  styleUrls: ['./dynamic-header.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DynamicHeaderComponent implements OnInit, AfterViewInit, OnDestroy {

  headerDetails: DynamicHeader;

  navbarOpen = false;
  contractbarOpen = false;
  userbarOpen = false;
  showmessage = false;
  showfaq = false;
  showcontract = false;
  messageCount = 0;
  contractList = Array<ContractMenuItem>();
  username = '';
  @ViewChild(LogoutConfirmationComponent) logoutConfirmation: LogoutConfirmationComponent;

  @ViewChild('headerList') headerList: ElementRef<HTMLDivElement>;
  @ViewChild('navbar') navbar: ElementRef<HTMLDivElement>;
  subscriptions: Subscription = new Subscription();
  routeNames = RouteNames;
  Icon = Icon;
  currentRoute: string;
  resizeSubscription: Subscription;
  activeHeaderLinks = [false, false];
  constructor(
    private screenSizeService: ScreenSizeService,
    private renderer: Renderer2,
    private elementRef: ElementRef,
    private customerService: CustomerService,
    private router: Router,
    private userAuthentication: UserAuthenticationService,
    private session: SessionService,
    private route: ActivatedRoute,
    private helperService: HelperService,
  ) { }

  ngOnInit(): void {
    this.session.hasHeaderRefreshed().subscribe(flag => {
      if (flag){
        this.fetchHeaderData(true);
      }
    });
    this.fetchHeaderData();
    this.determineActiveLink();
   void this.router.events.forEach((event) => {
      if(event instanceof NavigationEnd) {
        this.determineActiveLink();
      }
    });
  }

  ngAfterViewInit(): void {
    this.subscriptions.add(
      this.screenSizeService.resize().subscribe((screenSize: ScreenSize) => {
        if (screenSize === ScreenSize.small || screenSize === ScreenSize.x_small || screenSize === ScreenSize.medium) {
          if (this.navbarOpen) {
            setTimeout(() => {
              this.calculateMenuHeight();
            });
          }
        }
      })
    );
  }

  toggleNavbar(): void {
    if (this.navbarOpen === false) {
      this.calculateMenuHeight();
    }
    this.navbarOpen = !this.navbarOpen;
  }

  showContractMenu(): void {

    if (this.contractList.length === 1) {
      const contract = this.contractList[0];
      if(contract.Branch == '26'){
        void this.router.navigate([`${this.routeNames.customerZone}/${this.routeNames.myFund}/${this.routeNames.myplan}/${contract.ContractUrl}/26`]);
       }else{
         void this.router.navigate([`${this.routeNames.customerZone}/${this.routeNames.myFund}/${this.routeNames.myplan}/${contract.ContractUrl}`]);
       }
      this.closeHambugerMenu();
    }
    else {
      this.contractbarOpen = !this.contractbarOpen;
    }
  }

  closeMenu(): void {
    this.userbarOpen = false;
    this.contractbarOpen = false;
  }

  showUserMenu(): void {
    this.userbarOpen = !this.userbarOpen;
  }
  GoToHome(): void {
    this.closeHambugerMenu();
    void this.router.navigate([`${this.routeNames.customerZone}/${this.routeNames.customerHome}`]);
  }

  NavigateToContract(contract: ContractMenuItem): void {
    this.closeHambugerMenu();
   if(contract.Branch == '26'){
    void this.router.navigate([`${this.routeNames.customerZone}/${this.routeNames.myFund}/${this.routeNames.myplan}/${contract.ContractUrl}/26`]);
   }else{
     void this.router.navigate([`${this.routeNames.customerZone}/${this.routeNames.myFund}/${this.routeNames.myplan}/${contract.ContractUrl}`]);
   }
  }
  GoToProfile(): void {
    this.closeHambugerMenu();
    void this.router.navigate([`${this.routeNames.customerZone}/${this.routeNames.myprofile}`]);
  }

  logoutConfirmOpen():void{

    this.logoutConfirmation.logoutConfirmOpen();

  }

  closeHambugerMenu() {
    this.navbarOpen = false;
  }

  menuNavigation(menu) {
    this.closeHambugerMenu();
    if (menu === 'faq') {
      void this.router.navigate([`${this.routeNames.customerZone}/${this.routeNames.faq}`]);
    }
    else if (menu === 'message') {
      void this.router.navigate([`${this.routeNames.customerZone}/${this.routeNames.messages}`]);
    }

  }


  calculateMenuHeight() {
    const navBarHeight = this.navbar.nativeElement.clientHeight;
    const body = (this.elementRef.nativeElement as HTMLElement).closest('body');
    const bodyHeight = body.clientHeight;
    this.renderer.setStyle(this.headerList.nativeElement, 'height', `${bodyHeight - navBarHeight}px`, RendererStyleFlags2.Important);
  }

  generateContractList() {
    this.contractList = Array<ContractMenuItem>();
    if (this.headerDetails && this.headerDetails.ListContractViewModel && this.headerDetails.ListContractViewModel.length > 0) {
      this.headerDetails.ListContractViewModel.forEach(contractItem => {
        const contract = new ContractMenuItem();
        contract.ContractName = contractItem.CommercialName;
        contract.ContractNumber = contractItem.ContractReferenceNumber;
        contract.ContractUrl = contractItem.PlanId.toString();
        contract.Branch = contractItem.Branch;
        this.contractList.push(contract);
      });
    }
  }

  setUserName() {
    const person = this.customerService.getCustomerDetails();
    const firstName = this.helperService.getSessionValue(SessionKeys.firstName);
    if (person) {
      this.username = person.PersonFirstName ? person.PersonFirstName : '';
    }
    else {
      this.username = firstName ? firstName : '';
    }
  }

  setMenuOption() {
    this.showmessage = false;
    this.showcontract = (this.headerDetails &&
      this.headerDetails.ListContractViewModel &&
      this.headerDetails.ListContractViewModel.length > 0) ? true : false;
    this.showfaq = this.showcontract;
    if (this.showmessage && this.headerDetails && this.headerDetails.MessageCount > 0) {
      this.messageCount = this.headerDetails.MessageCount;
    }
    this.generateContractList();
    this.setUserName();
  }

  fetchHeaderData(isRefresh = false){
    if (!this.customerService.getHeaderDetails() || isRefresh) {
      this.customerService.getDynamicHeaderFromDB(Number(localStorage.personId)).subscribe(
        (dynamicHeader: DynamicHeader) => {
          if (dynamicHeader) {
            this.headerDetails = dynamicHeader;
            this.customerService.setHeaderDetails(dynamicHeader);
          }
          this.setMenuOption();
        });
    }
    else {
      this.headerDetails = this.customerService.getHeaderDetails();
      this.setMenuOption();
    }
  }

  private determineActiveLink(): void{
    this.currentRoute = this.router.url;
    if (this.currentRoute.includes(RouteNames.customerHome) || this.currentRoute.includes(RouteNames.iContinue)){
      this.activeHeaderLinks = [true, false];
    }
    else if (this.currentRoute.includes(RouteNames.myFund)){
      this.activeHeaderLinks = [false, true];
    }
    else{
      this.activeHeaderLinks = [false, false];
    }
  }

  // Optimization needed
  @HostListener('document:click', ['$event'])
  @HostListener('document:touchstart', ['$event'])
  handleOutsideClick(event: Event) {
    const screensize = this.screenSizeService.getScreenSize();
    const htmlElement = this.elementRef.nativeElement as HTMLElement;
    if (screensize === ScreenSize.large || screensize === ScreenSize.x_large) {
      if (this.contractbarOpen || this.userbarOpen) {
        const clickableElemContract = htmlElement.querySelector('.contract-menu-item a');
        const clickableElemUser = htmlElement.querySelector('.user-info-item a');
        if (clickableElemContract && !clickableElemContract.contains(event.target as HTMLInputElement)) {
          this.contractbarOpen = false;
        }
        if (!clickableElemUser.contains(event.target as HTMLInputElement)) {
          this.userbarOpen = false;
        }
      }
    }
  }



  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}
